import localeOrder from '@/views/order/list/locale/zh-CN';
import localeMessageBox from '@/components/message-box/locale/zh-CN';
import localeLogin from '@/views/login/locale/zh-CN';

import localeWorkplace from '@/views/dashboard/workplace/locale/zh-CN';
/** simple */
import localeMonitor from '@/views/dashboard/monitor/locale/zh-CN';

import localeSearchTable from '@/views/list/search-table/locale/zh-CN';
import localeCardList from '@/views/list/card/locale/zh-CN';

import localeStepForm from '@/views/form/step/locale/zh-CN';
import localeGroupForm from '@/views/form/group/locale/zh-CN';

import localeBasicProfile from '@/views/profile/basic/locale/zh-CN';

import localeDataAnalysis from '@/views/visualization/data-analysis/locale/zh-CN';
import localeMultiDAnalysis from '@/views/visualization/multi-dimension-data-analysis/locale/zh-CN';

import localeSuccess from '@/views/result/success/locale/zh-CN';
import localeError from '@/views/result/error/locale/zh-CN';

import locale403 from '@/views/exception/403/locale/zh-CN';
import locale404 from '@/views/exception/404/locale/zh-CN';
import locale500 from '@/views/exception/500/locale/zh-CN';

import localeUserInfo from '@/views/user/info/locale/zh-CN';
import localeUserSetting from '@/views/user/setting/locale/zh-CN';
/** simple end */
import localeBiggieCard from '@/views/users/setting/locale/zh-CN';
import localeReward from '@/views/reward/list/locale/zh-CN';
import localeBiggie from '@/views/biggie/list/locale/zh-CN';
import localeUsers from '@/views/users/list/locale/zh-CN';
import localeRechargeLog from '@/views/recharge-log/list/locale/zh-CN';
import localeSettings from './zh-CN/settings';

export default {
  'menu.dashboard': '仪表盘',
  'menu.list': '列表页',
  'menu.gift': '礼物列表页',
  'menu.result': '结果页',
  'menu.exception': '异常页',
  'menu.form': '表单页',
  'menu.profile': '详情页',
  'menu.profile.basic': '基础详情页',
  'menu.profile.recharge': '充值钻石',
  'menu.visualization': '数据可视化',
  'menu.user': '个人中心',
  'navbar.docs': '文档中心',
  'navbar.action.locale': '切换为中文',
  'recharge.title': '充值钻石',
  'recharge.amount': '充值数量',
  'recharge.amountPlaceholder': '请输入充值钻石数量',
  'recharge.amountTip': '最低充值1000钻石',
  'recharge.amountError': '充值数量不能少于1000钻石',
  'recharge.paymentMethod': '支付方式',
  'recharge.paypalDesc': '支持信用卡、借记卡及PayPal账户',
  'recharge.diamondAmount': '钻石数量',
  'recharge.usdAmount': '美元金额',
  'recharge.handlingFee': '手续费',
  'recharge.totalAmount': '总计',
  'recharge.submit': '立即充值',
  'recharge.reset': '重置',
  'recharge.redirecting': '正在跳转到支付页面...',
  'recharge.failed': '创建充值订单失败',
  ...localeSettings,
  ...localeMessageBox,
  ...localeLogin,
  ...localeWorkplace,
  /** simple */
  ...localeMonitor,
  ...localeSearchTable,
  ...localeCardList,
  ...localeStepForm,
  ...localeGroupForm,
  ...localeBasicProfile,
  ...localeDataAnalysis,
  ...localeMultiDAnalysis,
  ...localeSuccess,
  ...localeError,
  ...locale403,
  ...locale404,
  ...locale500,
  ...localeUserInfo,
  ...localeUserSetting,

  ...localeOrder,
  ...localeBiggieCard,
  ...localeReward,
  ...localeBiggie,
  ...localeUsers,
  ...localeRechargeLog,
  /** simple end */
};
